export default __webpack_public_path__ + "static/media/coffee.eefb259e.png";